import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {
  view: 'today'
}

const todayMenu = createSlice({
  name: 'today_menu',
  initialState,
  reducers: {
    selectTodayViewMode (state, action) {
      return { ...state, view: action.payload }
    }
  }
})

const persistConfig = {
  key: 'today_menu',
  storage
}

export const { selectTodayViewMode } = todayMenu.actions
export const TodayMenuReducer = persistReducer(
  persistConfig,
  todayMenu.reducer
)
